import { useState } from "react";
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  CircularProgress,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import { handleMenuItemClick } from "../handleMenuItemClick.function";

export const CustomListItem = ({ menuItem, isSelected, open }) => {
  const history = useNavigate();
  // Tracks in-flight async menu actions (e.g. downloading the user manual)
  const [isLoading, setIsLoading] = useState(false);

  const onClick = async () => {
    if (!menuItem.action) {
      handleMenuItemClick(menuItem, history);
      return;
    }
    setIsLoading(true);
    try {
      await handleMenuItemClick(menuItem, history);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ListItem
      disablePadding
      sx={{
        borderRadius: "7px",
        marginBottom: 1.5,
        justifyContent: "center",
      }}
    >
      <ListItemButton
        sx={{
          backgroundColor:
            isSelected === menuItem.route && "#f6f6f6 !important",
        }}
        onClick={onClick}
        disabled={isLoading}
      >
        <ListItemIcon
          sx={{
            color: isSelected === menuItem.route && "black",
            fontSize: { xs: "12px", md: "14px" },
          }}
        >
          {isLoading ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            menuItem.icon
          )}
        </ListItemIcon>
        <ListItemText
          primary={menuItem.title}
          primaryTypographyProps={{
            fontSize: { xs: "12px", md: "14px" },
            fontWeight: isSelected === menuItem.route && 600,
            color: "black",
          }}
          sx={{ opacity: open ? 1 : 0 }}
        />
      </ListItemButton>
    </ListItem>
  );
};
